export default function HeroLeft({ leftVisible, onSignup }) {
  const cls = `reveal${leftVisible ? ' in' : ''}`;

  return (
    <div>
      <h1 className={cls} id="h1heading">
        <span id="h1l1">Quản lý đa tài sản với</span><br />
        <em id="h1l2" style={{ fontSize: '35px' }}>
          lợi nhuận tối đa, rủi ro tối thiểu<span className="h1-cursor"></span>
        </em>
      </h1>

      <p className={`sub ${cls}`} id="rv0">
        Đảm bảo danh mục tài sản của bạn luôn ở trạng thái tối ưu, dù thị trường biến động như thế nào.
      </p>

      <div
        className={cls}
        id="tagStack"
        style={{
          marginBottom: '16px',
          borderTop: '1px solid #E5E7EB',
          borderBottom: '1px solid #E5E7EB',
          padding: '14px 0',
          display: 'inline-block',
        }}
      >
        <p style={{ fontSize: '12px', fontWeight: 600, color: 'var(--muted)', letterSpacing: '.06em', textTransform: 'uppercase', marginBottom: '4px' }}>
          Lãi kép/năm
        </p>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px' }}>
          <span style={{ fontSize: '42px', fontWeight: 800, color: '#059669', letterSpacing: '-.03em', lineHeight: 1 }}>47.8%</span>
        </div>
        <p style={{ fontSize: '12px', color: 'var(--muted)', marginTop: '6px' }}>Backtest 5 năm · Từ 2020</p>
      </div>

      <ul className={`feats ${cls}`} id="rv2">
        <li><span className="chk">✓</span>Gợi ý phân bổ tối ưu tài sản theo từng giai đoạn thị trường, bao gồm cổ phiếu, vàng, tiền gửi, crypto</li>
        <li><span className="chk">✓</span>Tự động phòng thủ khi thị trường lao dốc, hạn chế thua lỗ trước khi quá muộn</li>
        <li><span className="chk">✓</span>Chia nhỏ và tự động khớp lệnh lớn theo từng nhịp, tránh trượt giá như khi đặt thủ công</li>
      </ul>

      <div className={`ctas ${cls}`} id="rv3">
        <button className="btn-p" onClick={onSignup}>Bắt đầu miễn phí →</button>
      </div>

      <p className={`proof ${cls}`} id="rv4">
        Kiểm chứng <strong>5 năm dữ liệu thực</strong> · Minh bạch, không ước tính
      </p>
    </div>
  );
}
